import React, { Component, Fragment } from "react";
import Posscreen from "../../components/POS/";
import InjazHeader from "../../components/HeaderEn/";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import axios from "axios";
import URL from "../../constants/API_URL";

import { message, Layout } from "antd";
const { Content } = Layout;
class POS extends Component {
  componentWillMount() {
    this.checkToken();
  }
  checkToken = async () => {
    localStorage.getItem("accessToken") &&
      (await axios({
        method: "POST",
        url: URL + "auth/validateToken",
        data: {
          bearerToken:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (!res.data) {
            let clientName = localStorage.getItem("client_name");
            localStorage.clear();
            setTimeout(() => {
              localStorage.setItem("client_name", clientName);
              this.props.history.push("/poslogin/" + clientName);
              window.location.reload();
            }, 300);
          }
        })
        .catch((err) => {
          let clientName = localStorage.getItem("client_name");
          localStorage.clear();
          setTimeout(() => {
            localStorage.setItem("client_name", clientName);
            this.props.history.push("/poslogin/" + clientName);
            window.location.reload();
          }, 300);
        }));
  };
  render() {
    if (
      this.props.user.clientId &&
      this.props.user.accessToken &&
      localStorage.getItem("accessToken")
    ) {
      return (
        <Fragment>
          <InjazHeader posProps={true} />
          <Content
            style={{ paddingTop: 24, background: "#ecf0f5", width: "100%" }}
          >
            <Posscreen {...this.props} />
          </Content>
        </Fragment>
      );
    } else {
      if (localStorage.getItem("client_name")) {
        return (
          <Redirect
            to={{
              pathname: `/poslogin/${localStorage.getItem("client_name")}`,
            }}
          />
        );
      } else {
        return (
          <Redirect
            to={{
              pathname: "/poslogin/sandwichFactory.",
            }}
          />
        );
      }
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(POS));
